<template>
  <v-container>
    <v-card>

      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold">Firmar {{formTitle}}</h2>
        <v-spacer></v-spacer>
        <!-- <v-btn color="#0A4A79" dark to="/panel" small> -->
        <v-btn color="#0A4A79" class="mr-1" dark :to="currentOrden.secretario_id ? '/escritos/panel' : '/panel'" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
        <v-btn color="#0A4A79" dark to="/escritos/show" small class="ml-3">
          <v-icon small class="mr-5">mdi-file</v-icon>
          Ir al Escrito
        </v-btn>
      </v-card-title>
      <v-divider inset></v-divider>
      <v-card-text style="color: grey" class="font-weight-black">
        <v-row class="mb-n5">
          <v-col cols="12" md="6">
            <div v-if="currentOrden.sala_id < 12">
              <h4 v-if="currentOrden.numero_completo != 0"><span style="color: darkslategrey">NUM. DE TOCA: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE TOCA: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <div  v-if="currentOrden.sala_id == 12">
              <h4 v-if="currentOrden.numero_completo != 0 || currentOrden.sala_id == 12"><span style="color: darkslategrey">NUM. DE ASUNTO: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE ASUNTO: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <span class="font-weight-small  mr-3" style="color: #225882">ESTATUS:</span>
                      <u v-if="currentOrden.status==2" style="color: green">Registrada</u>
                      <u v-if="currentOrden.status==3" style="color: green">Contestada</u><br>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <span v-if="!currentOrden.secretario_id" class="font-weight-small black--text mr-3">Abogado:</span>
            <span v-else-if="currentOrden.secretario_id" class="font-weight-small black--text mr-3">Secretario:</span>
              <u v-if="!currentOrden.secretario_id">{{ currentOrden.abogado }}</u>
              <u v-else-if="currentOrden.secretario_id">{{ currentOrden.secretario }}</u><br>
            <span class="font-weight-small black--text mr-3">Email:</span>
              <u v-if="!currentOrden.secretario_id">{{ currentOrden.abogado_email }}</u>
              <u v-else-if="currentOrden.secretario_id">{{ currentOrden.secretario_email }}</u><br>
            <span class="font-weight-small black--text mr-3">Fecha de envío:</span><u>{{currentOrden.created_at | formatDate}}</u><br>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <!-- <v-row>
            <v-col v-if="currentOrden.tipo == 2" cols="12" md="8" align="left">
              <h3 class="font-weight-bold">Contestación a la presentación de la Promoción en Proceso de Multifirma</h3>
            </v-col>
          </v-row>
          <br> -->

          <!-- Multifirma -->

          <!-- <v-card> -->

            <template>
              <v-container>
              <v-card
                class="mx-auto"
              >
                <v-list shaped>
                  <v-subheader><h2>Firmas de Magistrados</h2>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue darken-3" dark @click="getFile()">
                      <v-icon small left>mdi-file-document</v-icon>
                      ver {{formTitle}}</v-btn>
                  </v-subheader>
                  <v-list
                    multiple
                  >
                    <template v-for="(item, i) in firmasList">
                      <v-divider></v-divider>

                      <v-list-item>
                        <v-list-item-avatar color="#AF8936">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                          <v-list-item-content>
                            <h3 v-if="item.magistrado.segundo_apellido">
                              {{item.magistrado.nombre+' '+item.magistrado.primer_apellido+' '+item.magistrado.segundo_apellido}}
                            </h3>
                            <h3 v-else>{{item.magistrado.nombre+' '+item.magistrado.primer_apellido}}
                            </h3>
                            <h3 v-if="item.firmado == 1">Firmado
                              <v-icon color="green">
                                mdi-file-check
                              </v-icon>
                            </h3>
                            <h3 v-else>Pendiente de Firma
                              <v-icon color="red">
                                mdi-file-remove
                              </v-icon>
                            </h3>
                          </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-list>
              </v-card>
              </v-container>
            </template>

            <v-container v-if="!firmado">
              <v-card
                class="mx-auto"
              >
                <v-alert
                  border="top"
                  colored-border
                  type="error"
                  elevation="2"
                >
                  <b>¡Es Necesaria la Firma de todos los Magistrados para enviar una Contestación!</b>
                </v-alert>
              </v-card>
          </v-container>

            <v-container v-if="firmado">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    class="mt-n2 mb-n6"
                    outlined
                    dense
                    name="input-7-1"
                    label="Extracto"
                    value=""
                    v-model="descripcion"
                    rows="4"
                    :rules="[v => !!v|| 'Registre un extracto']"
                    counter="255"
                    maxlength="255"
                  ></v-textarea>
                </v-col>
              </v-row>
              <!-- <v-card
                v-if="!firmado"
                class="mx-auto"
              >
                <v-alert
                  border="top"
                  colored-border
                  type="warning"
                  elevation="2"
                >
                  <b>¡Es Necesaria la Firma de todos los Magistrados para emitir una Contestación!</b>
                </v-alert>
              </v-card> -->
            <v-card
              class="mx-auto"
            >
            <v-row>
              <v-col cols="12" md="9">
                <v-row class="">
                  <v-col cols="12">
                    <p class="font-weight-black" align="center">Se dispone a Firmar {{formTitle}} el Secretario de Acuerdos</p>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-3">
                  <v-col cols="12" md="10" align="">
                    <v-file-input
                      v-model="filePFX"
                      color="blue darken-2"
                      label="Seleccionar la firel"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      multiple
                      show-size
                      accept=".pfx"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-3">
                  <v-col cols="12" md="10">
                    <v-text-field outlined dense
                      v-model="password"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-row class="">
                      <v-col cols="2">
                        <v-btn
                          :loading="loadingFirma"
                          :disabled="!activarBoton"
                          @click="AgregarFirmante()"
                          color="primary">Firmar {{formTitle}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

              </v-col>

            </v-row>
            <v-row>
            <v-col v-if="archivo.file_name" class="mt-n6 ml-6">
              <ul>
                <li>
                  <span><b>Contestación Firmada:</b>
                    {{ archivo.file_name }}
                    <v-icon
                     color="green"
                   >mdi-check</v-icon>&nbsp;
                   <v-btn
                     x-small
                     @click="saveTextAsFile()"
                     color="primary">Ver Evidencia
                   </v-btn>&nbsp;
                 </span>
                </li>
              </ul>
            </v-col>
            </v-row>
          </v-card>
        </v-container>
      <br>

          <!-- </v-card><br> -->

          <v-row>
            <v-col cols="12" align="right">
              <v-btn
                v-if="currentOrden.status == 2 && (currentOrden.proceso_multifirma == 1 || currentOrden.fecha_sentencia || currentOrden.fecha_amparo)  && firmado"
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                {{btnTitle}}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { _filesToSign, _Keys, AddSignSecretario, Sign, SignMultifirma, PKCS7creado } from '@/services/multifirma';
  import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {
        // tipo_firmado:'Firel',
        magistrado:'',
        magistrados: ['Mgdo. Tomás Aguilar Robles'],
        pkcs7:'',
        dialogPdf: false,
        loading: false,
        progress: false,
        valid: true,
        showpass: false,
        loadingFirma: false,
        activarBoton: false,
        firmado: '',
        // filePFXselct: false,
        Keys: [],
        descripcion: '',
        // expediente: '',
        currentOrden:'',
        bufferFile: '',
        files:[],
        file:[],
        filePFX: [],
        url_contestacion:'',
        nombre_contestacion:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        sign:true,
        user:'',
        password:'',
        // MagistradosList: [
        //   { id: 1, nombre: 'Mgdo. Tomás Aguilar Robles' },
        //   { id: 2, nombre: 'Mgdo. José Luis Álvarez Pulido'},
        //   { id: 3, nombre: 'Mgdo. Espartaco Cedeño Muñoz'},
        // ],
        fileRules: [
          // value => !value || value.size < 10000000 || 'Selecciona un Archivo de máximo 10 MB!',
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      formTitle () {
        if (this.currentOrden.fecha_sentencia) {
          return 'Sentencia'
        }
        if (this.currentOrden.fecha_amparo) {
          return 'Amparo'
        }
        // else if (this.currentOrden.sala_id === 13) {
        //   return 'Buzón Presidencia'
        // }
        return 'Acuerdo'
      },
      btnTitle () {
        if (this.currentOrden.fecha_sentencia || this.currentOrden.fecha_amparo) {
          return 'Enviar Firmas'
        }
        return 'Contestar'
      },
      ...mapGetters(["currentUser", "firmasList"]),
    },
    watch: {
      filePFX: function (val) {
        this.activarBoton = true
        if(!val.length){
          this.activarBoton = false
        }
      },
    },
    mounted() {
      this.currentOrden =  JSON.parse(localStorage.getItem("currentOrden"))
      this.getFirmas();
      this.getBufferFile();
    },
    methods:{
      //Metodos Firel
      AgregarFirmante() {
        if (this.password) {
          AddSignSecretario(this.filePFX, this.password).then((isValidFile) => {
            if (isValidFile) {
              // console.log('Archivo PFX cargado');
              // console.log('_Keys', _Keys);
              this.Keys.push(_Keys[0])
              // console.log('Keys', this.Keys);
              this.password = "";
              this.filePFX = [];
              this.firmar()
            } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Archivo PFX o contraseña invalida, Favor de Verificar',
                  confirmButtonText: "Aceptar",
                })
                this.password = "";
                this.filePFX = [];
                this.activarBoton = false
            }
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Ingrese su contraseña',
            showConfirmButton: false,
            timer: 1500
          })
        }
      },

      firmar() {
        if (this.currentOrden.fecha_sentencia || this.currentOrden.fecha_amparo) {
          var fileName = this.currentOrden.previo_url.split('/')[1];
        } else {
          var fileName = this.currentOrden.previo_contestacion.split('/')[1];
        }
        // var extFileUpload= files[i].name.split('.')[1];
        // var fileName = this.currentOrden.previo_contestacion.split('/')[1];
        var realName = fileName.split('.pdf')[0]
        // console.log(realName);
        SignMultifirma(this.Keys, this.bufferFile, fileName).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                // this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                this.FileName = "pkcs7_" + fecha.valueOf() + ".pdf" ;
                // console.log(PKCS7creado);
                this.creaEvidencia(this.pkcs7);
            }
         });
      },

      creaEvidencia(pkcs7)
      {
        Swal.fire({
          title: 'Estableciendo comunicación',
          html: 'Generando Evidencia Criptográfica ...',
          // timer: 5000,
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        this.creaevidencia=true;
        this.loadingFirma = true;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           // console.log(CertificateRequest);
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest }).then(response => {
             Swal.close();
             // console.log(response.data);
             this.loadingFirma = false;
             Swal.fire({
               icon: 'success',
               title: 'Contestación Firmada con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
             this.archivo.encode = response.data.data.PdfBase64;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
             // console.log(this.archivo);
             this.filePFX = [];
             this.file = [];
             this.password = '';
             this.activarBoton = false;
           })
           .catch(err => {
             console.log(err);
             this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },

      validate() {
        if (this.$refs.form.validate()) {
          if(this.archivo.encode == ''){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Firmar',
              confirmButtonText: "Aceptar",
            })
          } else
          if (this.sign == true) {
            this.loading = true
            if(this.currentOrden.sala_id == 12){
              // this.url_contestacion = "/expediente/"+this.currentOrden.id+"/contestacion"
              // this.nombre_contestacion = 'Expediente_Laboral'
            }
            else if(this.currentOrden.sala_id == 13) {
              // this.url_contestacion = "/buzon/"+this.currentOrden.id+"/contestacion"
              // this.nombre_contestacion = 'Escrito_Buzon'
            } else if(this.currentOrden.fecha_sentencia) {
              this.url_contestacion = "/sentencia/"+this.currentOrden.id+"/contestacion"
              this.nombre_contestacion = 'Contestacion_Sentencia'
            } else if(this.currentOrden.fecha_amparo) {
              this.url_contestacion = "/amparo/"+this.currentOrden.id+"/contestacion"
              this.nombre_contestacion = 'Contestacion_Amparo'
            } else {
              this.url_contestacion = "/promocion/"+this.currentOrden.id+"/contestacion"
              this.nombre_contestacion = 'Contestacion_Promocion'
            }
            this.save()
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },

      save() {
        const data = {
          // contestacion: this.respuesta,
          texto: this.descripcion,
          file: this.archivo,
          nombre: this.nombre_contestacion
        }
        if (this.currentOrden.tipo == 2) {
          data.nombre = 'Acuerdo_Promocion'
        }
        // if (this.currentOrden.secretario_id) {
        if (this.currentOrden.fecha_sentencia) {
          data.nombre = 'Documento_Sentencia'
        }
          // else if (this.currentOrden.fecha_amparo) {
          //   data.nombre = 'Documento_Amparo'
          // }
        // }
        // console.log(data);
        this.$store.dispatch("SAVE_CONTESTACION",  { url: this.url_contestacion, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Contestación Enviada',
            timer: 1500,
          })
          this.loading = false
          // this.close();
          if (this.currentOrden.fecha_sentencia || this.currentOrden.fecha_amparo) {
            this.$router.push('/escritos/panel')
          } else {
            this.$router.push('/panel')
          }

        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },

      getFirmas() {
        var url = "/multifirma/"+ this.currentOrden.id +"/firmas"
        if (this.currentOrden.fecha_sentencia) {
          url = "/sentencia/"+ this.currentOrden.id +"/firmas"
        }
        if (this.currentOrden.fecha_amparo) {
          url = "/amparo/"+ this.currentOrden.id +"/firmas"
        }
        this.$store.dispatch("GET_FIRMAS",  { url: url })
          .then(response => {
            // console.log(response.data);
            var firmas = response.data.data.firmas
            var countfirmas = 0
            firmas.forEach(firma => {
              if (firma.firmado == 1) {
                countfirmas ++
                this.Keys.push(JSON.parse(firma.firma))
              }
            });
            // console.log(countfirmas);
            // console.log(firmas.length);
            if (firmas.length == countfirmas) {
              this.firmado = true
            } else {
              this.firmado = false
            }
            // console.log(this.Keys);
        })
        .catch(error => {
          console.log(error);
        });
      },
      getFile(){
        this.progress = true
        var url = "/promocion/"+ this.currentOrden.id +"/previo-multifirma"
        if (this.currentOrden.fecha_sentencia) {
          url = "/sentencia/"+ this.currentOrden.id +"/file"
        }
        if (this.currentOrden.fecha_amparo) {
          url = "/amparo/"+ this.currentOrden.id +"/file"
        }
        this.$store.dispatch("GET_FILE", { url: url }).then((response) => {
          // console.log(response.data);
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
          })
          .catch(err => {
            console.log(err);
            this.progress = false
          });
      },
      getBufferFile(){
        var url = "/promocion/"+ this.currentOrden.id +"/previo-multifirma"
        if (this.currentOrden.fecha_sentencia) {
          url = "/sentencia/"+ this.currentOrden.id +"/file"
        }
        if (this.currentOrden.fecha_amparo) {
          url = "/amparo/"+ this.currentOrden.id +"/file"
        }
        this.$store.dispatch("GET_FILE", { url: url })
        .then((response) => {
          this.bufferFile = response.data
          // console.log(this.bufferFile);
        })
        .catch(err => {
          console.log(err);
        });
      },

      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },

      close () {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.archivo = Object.assign({}, this.archivoDefault)
        // this.respuesta = ''
        this.descripcion = ''
        // this.expediente = ''
        this.files = []
        this.file = []
        this.bufferFile = ''
      },

    }
  }
</script>
